<div *transloco="let t" class="flex items-center gap-2 py-1 max-sm:flex-col-reverse">
  <ng-content />

  <button
    appearance="flat"
    class="ml-auto"
    data-testid="checkbox-all"
    tuiLink
    type="button"
    [disabled]="disabled || disabledItems.length === items?.length"
    (click)="toggleAll()">
    {{ items?.length === selection.length ? t('Tout désélectionner') : t('Tout sélectionner') }}
  </button>
</div>

<tui-scrollbar
  class="w-full flex-1 rounded-2xl border border-border-normal bg-background-primary pt-0!"
  data-testid="scroll-wrapper"
  scroll-tracker
  [threshold]="{ bottom: 100 }"
  (bottomThreshold)="loadNextPage.emit()">
  <tui-data-list
    class="py-1.5 [--tui-padding-inline:initial]"
    data-testid="opt-group"
    ngDefaultControl
    size="m"
    tuiMultiSelectGroup
    [emptyContent]="emptyContent"
    [ngModel]="selection">
    @for (item of items; track item.value) {
      <button tuiOption type="button" [disabled]="disabled || disabledItems.includes(item.value)" [value]="item.value">
        {{ item.display }}
      </button>
    }
  </tui-data-list>
</tui-scrollbar>

<ng-template #emptyContent>
  <p class="mx-auto my-4 max-w-prose text-center text-text-tertiary">{{ emptyMessage }}</p>
</ng-template>
